import type { BaseController } from '@infra/controllers/base.controller';
import type { BusTeamListPayload } from '@main/event-listeners/payloads/bus-team-list.payload';
import type { StoreTeamListUsecase } from './store-teamlist.usecase';

export type StoreTeamListOutput = void;

export class StoreTeamListController
  implements BaseController<BusTeamListPayload, StoreTeamListOutput>
{
  constructor(private usecase: StoreTeamListUsecase) {}

  async handle(payload: BusTeamListPayload): Promise<StoreTeamListOutput> {
    if (payload.searchTeams?.items?.length > 0) {
      await this.usecase.run(payload);
    }
  }
}
